export type BasicConnectors = {
    standardPlug: string;
    fastPlugObject?: FastPlug;
}

export type FastPlug = {
    fastPlug: string;
    fastPlugOptional: boolean;
}

export type FastChargeDetails = {
    Standard: string;
    Optional: boolean;
}

export type StandardChargeDetails = {
    Standard: string;
}

export enum ConnectorList {
    "Type 1" = "IEC_62196_T1",
    "Type 2" = "IEC_62196_T2",
    "Combo CCS" = "IEC_62196_T2_COMBO",
    "CHAdeMO" = "CHADEMO",
    "Domestic E" = "DOMESTIC_E",
    "Supercharger" = "TESLA_S"
}